import React from 'react';
import { Route, Routes } from 'react-router-dom';
import DocumentList from './DocumentList';
import DocumentForm from './DocumentForm';

const DocumentRoutes = () => {
  return (
    <Routes>
      <Route index element={<DocumentList />} />
      <Route path="new" element={<DocumentForm />} />
      <Route path="edit/:id" element={<DocumentForm />} />
    </Routes>
  );
};

export default DocumentRoutes; 